import axios from 'axios';

// Utilisation du serveur RDFox local au lieu de l'URL AWS distante
const RDFOX_URL = 'http://localhost:12110';

// Informations d'authentification pour RDFox
const RDFOX_AUTH = {
  username: 'admin',
  password: 'grM3bgZiQkq9YQc'
};

const fetchRDFoxData = async (datastore: string, query: string) => {
    const endpoint = `${RDFOX_URL}/datastores/${datastore}/sparql`;
    
    try {
        console.log(`Fetching data from ${endpoint}`);
        console.log('Query:', query);
        
        const response = await axios.post(endpoint, query, {
            headers: {
                'Content-Type': 'application/sparql-query',
                'Accept': 'application/sparql-results+json'
            },
            auth: RDFOX_AUTH
        });

        console.log('Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching data from RDFox:', error);
        throw error;
    }
};

export default fetchRDFoxData;
